<template>
  <div>
    <div class="log">
      <div class="block_2">
        <span class="text_1">欢迎使用</span>
        <div class="text-group_6">
          <span class="text_2">浙江省卫生健康委员会</span>
          <span class="text_3"
            >HEALTH&nbsp;COMMISSION&nbsp;OF&nbsp;ZHEJIANG&nbsp;PROVINCE</span
          >
          <span class="text_4">医学科教资讯与服务平台</span>
        </div>
      </div>
      <div class="block_1">
        <!-- <el-input v-model="" placeholder="" size="normal" clearable @change=""></el-input> -->
        <loginbox></loginbox>
      </div>
    </div>
    <!-- <div class="logo_header">
      <img class="logo" :src="require('../assets/images/login-logo.png')" alt />
    </div> -->
    <!-- <div class="logo_banner" v-loading="loading"  element-loading-text="登录中，请稍后"   element-loading-background="rgba(0, 0, 0, 0.5)">
      <div class="container">
        <div class="logo_box">
          <div class="login-tab">
            <div class="tab_header">
              <div class="div1">
                <span @click="schange(1)" class="sp1" :class="sel==1?'change':''">账号登录</span>
                <span @click="schange(2)" class="sp2" :class="sel==2?'change':''">修改密码</span>
              </div>
             
            </div>
          </div>
          <div class="tab-pane">
            <loginbox @set="csel" v-if="sel==1" :class="sel==1?'change':''"></loginbox>
            <loginboxreset :class="sel==1?'change':''" @set="csel" v-if="sel==2"></loginboxreset>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="footer">
      版权所有 博库科技 ©2017 浙ICP13035740号
      <br />联系电话：0571-86680878
    </div> -->
  </div>
</template>

<script>
import loginbox from "../components/login/login_box";
import loginboxreset from "../components/login/login_box_reset";
export default {
  created() {
    if (this.$route.query.encryption) {
      sessionStorage.setItem("encryption", this.$route.query.encryption);
      sessionStorage.setItem("isLogin", 1);
      if (this.$route.query.name) {
        sessionStorage.setItem("hospitalName", this.$route.query.name);
      }
      this.$router.replace("/index");
      return;
    }
    if (this.$route.query.bucToken) {
      sessionStorage.setItem("bucToken", this.$route.query.bucToken);
    }
    if (this.$route.query.username && this.$route.query.password) {
      this.username = this.$route.query.username;
      this.password = this.$route.query.password;
    }
    // this.freeLogin();
  },
  components: {
    loginbox,
    loginboxreset,
  },
  data() {
    return {
      sel: 1,
      username: "",
      password: "",
      loading: false,
    };
  },
  methods: {
    schange(x) {
      this.sel = x;
    },
    // freeLogin() {
    //   this.loading = false;
    //   if (sessionStorage.getItem("bucToken")) {
    //     this.loading = true;
    //   }
    //   let obj = {
    //     condition: {
    //       loginName: this.username,
    //       password: this.password,
    //     },
    //   };
    //   this.$api
    //     .appLogin(obj)
    //     .then((res) => {
    //       this.loading = false;
    //       console.log(res);
    //       if (res.data.success) {
    //         this.$message({
    //           message: "登录成功",
    //           type: "success",
    //         });
    //         sessionStorage.setItem(
    //           "electronicPublicationStatus",
    //           res.data.data.electronicPublicationStatus
    //         );
    //         sessionStorage.setItem("hospitalName", res.data.data.realName);
    //         sessionStorage.setItem("telephone", res.data.data.telephone);
    //         sessionStorage.setItem("token", res.data.data.loginName);
    //         sessionStorage.setItem("isLogin", 1);
    //         this.$router.replace("/index");
    //       } else {
    //       }
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       console.log(err);
    //     });
    // },
    // ipConfirm() {
    //   let obj = {
    //     condition: {}
    //   };
    //   this.$api
    //     .appLogin(obj)
    //     .then(res => {
    //       console.log(res);
    //       if (res.data.success) {
    //         sessionStorage.setItem("hospitalName", res.data.data.realName);
    //         sessionStorage.setItem("token", res.data.data.loginName);
    //         sessionStorage.setItem("isLogin", 1);
    //         this.$message({
    //           message: "IP登录成功",
    //           type: "success"
    //         });
    //         this.$router.replace("/");
    //       } else {
    //       }
    //     })
    //     .catch(err => {console.log(err)});
    // },
    csel(x) {
      this.sel = x;
    },
  },
};
</script>

<style lang="scss" scoped>
.log {
  width: 100%;
  height: 100vh;
  background: url("../assets/背景图3.png") no-repeat 100%;
  position: relative;
}
.block_2 {
  width: 360px;
  height: 242px;
  position: absolute;
  top: 200px;
  left: 200px;
  .text_1 {
    width: 192px;
    height: 67px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 48px;
    font-family: PingFangSC-Semibold;
    text-align: left;
    white-space: nowrap;
    line-height: 67px;
  }
  .text-group_6 {
    width: 360px;
    height: 127px;
    margin-top: 48px;
    .text_2 {
      width: 360px;
      height: 50px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 36px;
      font-family: PingFangSC-Semibold;
      text-align: left;
      white-space: nowrap;
      line-height: 50px;
    }
    .text_3 {
      width: 348px;
      height: 18px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 13px;
      letter-spacing: 1.1645833253860474px;
      font-family: PingFangSC-Medium;
      text-align: left;
      white-space: nowrap;
      line-height: 18px;
      margin-top: 12px;
    }
    .text_4 {
      width: 280px;
      height: 40px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 28px;
      font-family: PingFangSC-Semibold;
      text-align: left;
      white-space: nowrap;
      line-height: 40px;
      margin-top: 7px;
    }
  }
}
.block_1 {
  position: absolute;
  top: 200px;
  right: 200px;
  width: 400px;
  height: 400px;
  border-radius: 10px;
  background-color: #fff;
}
</style>

<!-- <style scoped>
.div1 {
  position: absolute;
  width: 100%;
  height: 72px;
  top: 50px;
}
.div1 > span {
  color: #fff;
  font-size: 20px;
  background: rgba(255, 255, 255, 0.1);
  display: inline-block;
  width: 45%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  height: 50px;
  text-align: center;
  top: 32px;
  bottom: 4px;
  cursor: pointer;
  padding-top: 10px;
}
.change {
  color: #00ab71 !important;
  background: rgba(255, 255, 255, 0.15) !important;
}
.sp1 {
  left: 20px;
  top: 30px !important;
  position: absolute;
}
.sp2 {
  right: 5px;
  top: 30px !important;
  position: absolute;
}
.logo_header {
  height: 90px;
  background: #00ab71;
  position: relative;
}
.logo_header > .logo {
  /* height: 2.5; */
  width: 400px;
  /* height:180px; */
  position: absolute;
  top: -60px;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2;
}
.logo_banner {
  height: 100vh;

  background: url("../assets/背景图3.png") no-repeat 100%;
  background-size: 100% 100%;
  position: relative;
}
.logo_banner > .container {
  position: relative;
  padding: 0 0.22rem;
  margin-right: auto;
  margin-left: auto;
}
.logo_banner > .container > .logo_box {
  width: 300px;
  height: 260px;
  padding: 10px 30px 10px 30px;
  position: absolute;
  top: 100px;
  left: auto;
  right: 300px;
}
.tab_header {
  position: absolute;
  width: 100%;
  top: -0.65rem;
  left: 0;
}
.tab_header > .con {
  position: absolute;
  width: 100%;
  height: 44px;
  font-size: 30px;
  text-align: center;
  color: #fff;
  line-height: 44px;
  display: inline-block;
  font-family: SimHei;
  background: rgba(255, 255, 255, 0.2);
  top: 2.51rem;
  border-radius: 4px;
}

.tab-pane {
  width: 100%;
  height: 300px;
}
.footer {
  text-align: center;
  margin: 10px 0;
  color: #999;
  line-height: 24px;
  font-size: 14px;
}
</style> -->